import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

import AddCircle from '@mui/icons-material/AddCircle';
import Restore from '@mui/icons-material/Restore';
import Person from '@mui/icons-material/Person';
import Beenhere from '@mui/icons-material/Beenhere';

import { useSearchParams } from 'react-router-dom';

import { apiHelper, baseUrl } from 'helpers/util';
import { notify } from 'helpers/globalFunctions';
import ColumnBox from 'components/ColumnBox';
import BigHeading from 'components/BigHeading';

export default function Form() {
    const [ aggregateData, setAggregateData ] = useState(null);
    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ isDetailDialogOpen, setIsDetailDialogOpen ] = useState(false);
    const [ selectedBed, setSelectedBed ] = useState(null);
    const [ selectedStatus, setSelectedStatus ] = useState(null);
    const [ isStatusSaving, setIsStatusSaving ] = useState(false);

    const onDialogClose = function() {
        setIsDetailDialogOpen(false);
    }
    const loadResidencyData = function(residency_name) {
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_custom_api`,
            "params": { "residency_name": residency_name, "route": "folk_residency.room_aggregate" } })
        .then(response => {
            if (response.status) {  
                setAggregateData(response.json.message);
            }
            else { console.log(response.json); }
        })
    }
    const onClickBed = function(room, bedDetails) {
        setSelectedBed({ ...bedDetails, room });
        setSelectedStatus(bedDetails.residency_status);
        setIsDetailDialogOpen(true);
    }
    const onClickSaveStatus = function() {
        setIsStatusSaving(true);
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_custom_api`,
            "params": { "bed_name": selectedBed.bed_name, "new_status": selectedStatus,
                "route": "folk_residency.change_devotee_status" } })
        .then(response => {
            if (response.status) {}
            else {
                console.log(response.json);
                notify.error(JSON.stringify(response.json));
            }
            setIsStatusSaving(false);
        })
    }

    useEffect(function() {
        if (searchParams.get('residency_name')) {
            loadResidencyData(searchParams.get('residency_name'));
        }
    }, [])

    return (
        <>
        <ColumnBox sx={{ alignItems: 'center', padding: '10px' }}>
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>{ aggregateData ?
                aggregateData.residency_info.residency_name : '' }</span><br/>
            <span style={{ textAlign: 'center' }}>
                <span>Total beds: { aggregateData ?
                    aggregateData.residency_info.total_beds : '' } | </span>
                <span>Filled beds: { aggregateData ?
                    aggregateData.residency_info.occupied_beds : '' } | </span>
                <span>Vacant beds: { aggregateData ?
                    aggregateData.residency_info.vacant_beds : '' } | </span>
                <span>OOS FOLK: { aggregateData ?
                    aggregateData.residency_info.oos_boys : '' }</span>
            </span>
        </ColumnBox>

        { (aggregateData && aggregateData.bed_info && aggregateData.bed_info.length > 0) ?
        (<div style={{ "padding": "10px", "maxWidth": '800px', 'fontSize': '15px' }}>
            { aggregateData.bed_info.map(room => 
                (<div style={{ width: '100%', border: '0.5px solid black',
                    borderRadius: '10px', marginTop: '10px' }}>
                    <p style={{ textAlign: 'center', fontSize: '15px', fontWeight: 'bold' }}>{ room.room }</p>
                    <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}>
                        {(room.beds.map(bed => (
                            <Box sx={{ flex: '1 0 30%', display: 'flex',
                                alignItems: 'center', flexDirection: 'column', marginBottom: '5px' }}
                                onClick={() => onClickBed(room.room, bed)}>
                                <div key={bed.bed_name} className={ !bed.person_name ? 'vacant-bed' :
                                    (bed.person_name && (!bed.residency_status || bed.residency_status == 'In Residency')
                                    ? 'filled-bed'
                                    : (bed.person_name && bed.residency_status == 'Sick' ? 'sick-bed' :
                                    (bed.person_name && bed.residency_status == 'Out of Station' ? 'oos-bed' : '' ))) }
                                    style={{ cursor: 'pointer' }} >
                                    <span style={{ position: 'absolute', left: '50%', top: '13%',
                                        transform: 'translate(-50%,-25%)',
                                        fontSize: '15px', fontWeight: 'bold' }}>
                                        { bed.bed_no }
                                    </span>
                                </div>
                                <span style={{ textAlign: 'center', color: '#c37d5d' }}>{ bed.person_name }</span>
                            </Box>
                        )))}
                    </div>
                </div> ))
            }
        </div>)
        :
        <></>
        }
        <Dialog onClose={onDialogClose} open={isDetailDialogOpen}
            maxWidth='lg' fullWidth={true}>
            { selectedBed && <Box sx={{ height: '60vh' }}>
            <DialogTitle>{selectedBed.room} - {selectedBed.bed_no}</DialogTitle>
                <ColumnBox sx={{ alignItems: 'center' }}>
                    <Box>{selectedBed.person_name}</Box>
                    <Box>{selectedBed.mobile_number}</Box>
                    <ColumnBox sx={{ alignItems: 'center' }}>
                        <Autocomplete
                            disablePortal
                            size="small"
                            onChange={(e, val) => setSelectedStatus(val)}
                            value={selectedStatus}
                            options={["Out of Station", "Sick", "In Residency"]}
                            sx={{ minWidth: '200px', marginTop: '15px' }}
                            renderInput={(params) => <TextField {...params} label="Status" />}
                        />
                        {isStatusSaving ? <CircularProgress sx={{ marginTop: '15px' }} /> :
                            <Button onClick={() => onClickSaveStatus()} variant="outlined"
                                size="small" sx={{ marginTop: '15px' }}>Save Status</Button>}
                    </ColumnBox>
                </ColumnBox>
            </Box> }
        </Dialog>
        </>
    );
}
